export default {
  data() {
    return {
      templates: [],
    };
  },
  mounted() {
    this.loadTemplates();
  },
  methods: {
    loadTemplates() {
      const params = {
        active: true,
        limit: 0,
      };

      this.$http.get('/report-templates', { params })
        .then(({ data }) => {
          this.templates = data.items;
        })
        .catch(this.$toast.error);
    },
    loadTemplate(eye) {
      const templateId = eye === 'R' ? this.form.templateR : this.form.templateL;
      if (!templateId) return;

      this.$http.get(`/report-templates/${templateId}`)
        .then(({ data }) => {
          if (eye === 'R') {
            this.form.reportR = data.data;
          } else {
            this.form.reportL = data.data;
          }
        })
        .catch(this.$toast.error);
    },
  },
};
